import { businessArea, pdfArea, pricingArea, processingArea } from "~/router"
import { isRoute } from "~/utils"
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'

export const useArea = () => {

    const route = useRoute()

    const isArea = (area: string) =>
        isRoute(route, `/${area}`)

    const currentArea = computed(() => route.path.split('/')[1])

    const isPdfPage = computed(() => isArea(pdfArea))

    const isProcessingPage = computed(() => isArea(processingArea))

    const isPricingPage = computed(() => isArea(pricingArea))

    const isBusinessPage = computed(() => isArea(businessArea))

    return {
        currentArea,
        isPdfPage,
        isPricingPage,
        isBusinessPage,
        isProcessingPage
    }
}

export const useApi = () => {

    const route = useRoute()

    const path = computed(() => route.meta?.apiUrl as string | undefined ?? '')

    const entityId = computed(() => route.params['id'])

    const entityPath = computed(() => `${path.value}/${entityId.value}`)

    return {
        path,
        entityId,
        entityPath
    }
}